import { render, staticRenderFns } from "./QcUserDoctorDashboard.vue?vue&type=template&id=556729f5&scoped=true&"
import script from "./QcUserDoctorDashboard.vue?vue&type=script&lang=js&"
export * from "./QcUserDoctorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./QcUserDoctorDashboard.vue?vue&type=style&index=0&id=556729f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556729f5",
  null
  
)

export default component.exports